import React, {useContext} from 'react';
import AppContext from '../../../utility/AppContext';
import Box from '@material-ui/core/Box';
import {Button, makeStyles} from '@material-ui/core';
import clsx from 'clsx';
import {version} from '../../../../shared/constants/AppConst';
const AppFixedFooter = (props) => {
  // const {footer, footerType} = useContext(AppContext);
  let footerType = 'fixed';
  const useStyles = makeStyles((theme) => ({
    footer: {
      position: 'fixed',
      borderRadius:'7px 0px',
      right: 0,
      bottom: 0,
      width: 'auto',
      zIndex: 99,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      margin: '0',
      '& .footerContainer': {
        padding: '5px 20px',
        [theme.breakpoints.up('xl')]: {
          padding: '10px 20px',
        },
      },
    },
    btnRoot: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  }));

  const classes = useStyles(props);

  return (
    <>
      {footerType === 'fixed' ? (
        <Box
          className={clsx(classes.footer, 'footer fixed-footer')}
          style={{height: '22px'}}>
          <Box
            className='footerContainer'
            style={{marginRight: 0}}
            alignItems='center'
            flexDirection='row'
            display='flex'>
            <Box ml='auto' style={{fontWeight: '300'}}>
              Release #{version}
            </Box>
          </Box>
        </Box>
      ) : null}
    </>
  );
};

export default AppFixedFooter;
